import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import InputAdornment from "@mui/material/InputAdornment";

import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles((theme) => ({
	TextFieldStyle: {
		width: "100%",
		background: "#F2F4F7 !important",
		paddingRight: "0rem !important",
		borderRadius: "10px !important",
		fontSize: "1.6rem !important",
		fontFamily: "Inter-Medium !important",
		lineHeight: "2.4rem !important",
	},
	inputStyle: {
		fontFamily: "Inter-Medium !important",
		paddingRight: "0rem !important",
		fontSize: "1.6rem !important",
		lineHeight: "2.4rem !important",
		background: "#F2F4F7  !important",
		//   border: '1px solid #D0D5DD',
		boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
		border: "1px solid #F2F4F7",
		borderRadius: "10px !important",
		textTransform: "inherit !important",
		"& input": {
			fontSize: "1.6rem !important",
			lineHeight: "2.4rem !important",
			color: "#101828 !important",
			padding: "1.3rem 1.4rem",
			border: "none !important",
			boxShadow: "none !important",
			textTransform: "inherit !important",
		},

		"& input[text]": {
			color: "#101828 !important",
		},
		"& input[input:-internal-autofill-selected]": {
			background: "#F2F4F7 !important",
		},
		"& input[value]": {
			background: "#FFFFF !important",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"&.Mui-focused": {
			background: "#FFFFFF !important",
			border: "1px solid #84CAFF !important",
			boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
		},
		"&.Mui-error": {
			border: "1px solid red !important",
			boxShadow: "none !important",
		},
	},

	helperText: {
		background: "#FFFFFF !important",
		fontSize: "1.4rem !important",
		margin: "0rem 0 0 0 !important",
		fontFamily: "Inter-Medium !important",
		lineHeight: "1.8rem !important",
		paddingTop: "0.5rem !important ",
		textTransform: "initial !important",
	},
	helperTextColor: {
		background: "transparent !important",
		fontSize: "1.4rem !important",
		margin: "0rem 0 0 0 !important",
		fontFamily: "Inter-Medium !important",
		lineHeight: "1.8rem !important",
		paddingTop: "0.5rem !important ",
		textTransform: "initial !important",
	},
	startPhoneNumber: {
		"& p": {
			fontSize: "1.6rem !important",
			lineHeight: "2.4rem !important",
		},
		height: "100% !important",
		padding: "1rem 1.2rem",
		borderRight: "1px solid #D0D5DD",
	},
	textLabel: {
		"& p": {
			color: "#667085 !important",
			fontSize: "1.2rem !important",
			lineHeight: "2rem !important",
			textDecorationLine: "underline",
			fontFamily: "Inter-Medium",
			marginRight: "1rem",
		},
	},
	image: {
		width: "1.5rem !important",
		height: "1.5rem !important",
	},
	labelCss: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontSeight: 500,
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#344054",
		marginBottom: "0.6rem",
		textTransform: "initial !important",
	},
}));
//image=true (svg,png,jpeg)(inputType=label),icon1&icon2(position='startEnd)
function CustomInput({
	value,
	handleChange,
	placeholder = "",
	inputType = "text",
	helperText = "",
	icon1,
	icon2,
	clicked,
	position,
	labelText = "",
	image = false,
	disabled = false,
	greenTick = false,
	isLoading = false,
	mandatory = false,
	label = "",
	style,
	onKeyPress,
	helperColor,
}) {
	const classes = useStyles();
	const [passwordShow, setPasswordShow] = useState(false);
	// console.log(helperText);
	return (
		<>
			<div
				className={classes.labelCss}
				sx={{ fontSize: { md: "2rem", sm: "2rem" } }}
				style={{
					fontSize: window.innerWidth < 727 ? "2rem" : "1.4rem",
					marginBottom: window.innerWidth < 727 ? "1.6rem" : "0.6rem",
				}}
			>
				{label}
				{mandatory && <span style={{ color: "red" }}> *</span>}
			</div>
			{inputType === "tel" ? (
				<TextField
					disabled={disabled}
					value={value}
					onChange={(e) => {
						var numbers = /^[0-9]+$/;
						if ((e.target.value.match(numbers) || e.target.value === "") && e.target.value.length <= 10) {
							handleChange(e.target.value);
						}
					}}
					placeholder={placeholder}
					type={"tel"}
					helperText={helperText}
					error={helperText !== ""}
					className={classes.TextFieldStyle}
					InputProps={{
						className: classes.inputStyle,

						// style: { paddingLeft: "0" },
						startAdornment: (
							<InputAdornment className={classes.startPhoneNumber} position="start">
								+91
							</InputAdornment>
						),
					}}
					inputProps={{ min: 0 }}
					FormHelperTextProps={{ className: classes.helperText }}
				/>
			) : inputType === "password" ? (
				<TextField
					disabled={disabled}
					value={value}
					onChange={(e) => {
						handleChange(e.target.value);
					}}
					placeholder={placeholder}
					type={passwordShow ? "text" : "password"}
					helperText={helperText}
					error={helperText !== ""}
					className={classes.TextFieldStyle}
					onKeyPress={onKeyPress}
					InputProps={{
						className: classes.inputStyle,
						endAdornment: (
							<InputAdornment
								position="start"
								onClick={() => {
									setPasswordShow(!passwordShow);
								}}
								style={{ cursor: "pointer" }}
							>
								{passwordShow ? (
									<VisibilityOffOutlinedIcon style={{ fontSize: "2.5rem" }} />
								) : (
									<VisibilityOutlinedIcon style={{ fontSize: "2.5rem" }} />
								)}
							</InputAdornment>
						),
					}}
					inputProps={{ min: 0 }}
					FormHelperTextProps={{ className: classes.helperText }}
				/>
			) : inputType === "label" && position === "start" ? (
				<TextField
					disabled={disabled}
					value={value}
					onChange={(e) => {
						handleChange(e.target.value);
					}}
					placeholder={placeholder}
					helperText={helperText}
					error={helperText !== ""}
					className={classes.TextFieldStyle}
					onKeyPress={onKeyPress}
					InputProps={{
						className: classes.inputStyle,
						startAdornment: (
							<InputAdornment className={classes.textLabel} position={"start"} onClick={clicked} style={{ cursor: "pointer" }}>
								{image ? <img className={classes.image} src={labelText} alt="" /> : { labelText }}
							</InputAdornment>
						),
					}}
					inputProps={{ min: 0 }}
					FormHelperTextProps={{ className: classes.helperText }}
				/>
			) : inputType === "label" && position === "end" ? (
				<TextField
					sx={{
						"& .MuiOutlinedInput-root": {
							background: style?.background ? style?.background + "!important" : "",
							boxShadow: style?.boxShadow ? style?.boxShadow + "!important" : "none",
							border: style?.border ? style?.border + "!important" : "none",
							borderRadius: style?.borderRadius ? style?.borderRadius + "!important" : "none",
						},
						input: {
							color: "#667085 !important",
							background: style?.background ? style?.background + "!important" : "",
							borderRadius: style?.borderRadius ? style?.borderRadius + "!important" : "none",
						},
					}}
					disabled={disabled}
					value={value}
					onChange={(e) => {
						handleChange(e.target.value);
					}}
					placeholder={placeholder}
					helperText={helperText}
					error={helperText !== ""}
					className={classes.TextFieldStyle}
					onKeyPress={onKeyPress}
					InputProps={{
						className: classes.inputStyle,
						endAdornment: (
							<>
								{labelText && (
									<InputAdornment
										className={classes.textLabel}
										position={"end"}
										onClick={(e) => {
											clicked(labelText);
										}}
										style={{ cursor: "pointer" }}
									>
										{/* {image ? (
                  <img className={classes.image} src={labelText} alt="" />
                ) : ( */}
										{labelText}
										{/* )} */}
									</InputAdornment>
								)}
								{greenTick && (
									<InputAdornment className={classes.greenTick} position="end">
										<CheckCircleSharpIcon style={{ fontSize: "2.5rem", marginRight: "1rem" }} color={"success"} />
									</InputAdornment>
								)}
							</>
						),
					}}
					inputProps={{ min: 0 }}
					FormHelperTextProps={{ className: classes.helperText }}
				/>
			) : inputType === "icons" && position === "startAndEnd" ? (
				<TextField
					disabled={disabled}
					value={value}
					onChange={(e) => {
						handleChange(e.target.value);
					}}
					placeholder={placeholder}
					helperText={helperText}
					error={helperText !== ""}
					className={classes.TextFieldStyle}
					onKeyPress={onKeyPress}
					InputProps={{
						className: classes.inputStyle,
						startAdornment: (
							<InputAdornment className={classes.textLabel} position={"start"} onClick={clicked} style={{ cursor: "pointer" }}>
								{image ? <img className={classes.image} src={icon1} alt="" /> : icon1}
							</InputAdornment>
						),
						endAdornment: (
							<InputAdornment className={classes.textLabel} position={"end"} onClick={clicked} style={{ cursor: "pointer" }}>
								{image ? <img className={classes.image} src={icon2} alt="" /> : icon2}
							</InputAdornment>
						),
					}}
					inputProps={{ min: 0 }}
					FormHelperTextProps={{ className: classes.helperText }}
				/>
			) : inputType === "mobile" ? (
				<TextField
					sx={{
						"& .MuiOutlinedInput-root": {
							background: style?.background ? style?.background + "!important" : "",
							boxShadow: style?.boxShadow ? style?.boxShadow + "!important" : "none",
							border: style?.border ? style?.border + "!important" : "none",
							borderRadius: style?.borderRadius ? style?.borderRadius + "!important" : "none",
						},
						input: {
							color: "#667085 !important",
							background: style?.background ? style?.background + "!important" : "",
							borderRadius: style?.borderRadius ? style?.borderRadius + "!important" : "none",
						},
					}}
					disabled={disabled}
					value={value}
					onChange={(e) => {
						var numbers = /^[0-9]+$/;
						if ((e.target.value.match(numbers) || e.target.value === "") && e.target.value.length <= 10) {
							handleChange(e.target.value);
						}
					}}
					placeholder={placeholder}
					type={"number"}
					helperText={helperText}
					error={helperText !== ""}
					className={classes.TextFieldStyle}
					onKeyPress={onKeyPress}
					InputProps={{
						className: classes.inputStyle,
					}}
					inputProps={{ min: 0 }}
					FormHelperTextProps={{ className: helperColor ? classes.helperTextColor : classes.helperText }}
				/>
			) : (
				<TextField
					sx={{
						"& .MuiOutlinedInput-root": {
							background: style?.background ? style?.background + "!important" : "",
							textTransform: style?.textTransform ? style?.textTransform + "!important" : "",
							boxShadow: style?.boxShadow ? style?.boxShadow + "!important" : "none",
							border: style?.border ? style?.border + "!important" : "none",
							borderRadius: style?.borderRadius ? style?.borderRadius + "!important" : "none",
						},
						input: {
							color: "#667085 !important",
							background: style?.background ? style?.background + "!important" : "",
							borderRadius: style?.borderRadius ? style?.borderRadius + "!important" : "none",
						},
					}}
					disabled={disabled}
					value={value}
					onChange={(e) => {
						handleChange(e.target.value);
					}}
					placeholder={placeholder}
					type={inputType}
					helperText={helperText}
					error={helperText !== ""}
					className={classes.TextFieldStyle}
					onKeyPress={onKeyPress}
					InputProps={{
						className: classes.inputStyle,
						endAdornment: (
							<>
								{greenTick && (
									<InputAdornment className={classes.greenTick} position="end">
										<CheckCircleSharpIcon style={{ fontSize: "2.5rem", marginRight: "1rem" }} color={"success"} />
									</InputAdornment>
								)}
								{isLoading && (
									<InputAdornment position="end" sx={{ marginRight: "1rem" }}>
										<CircularProgress style={{ height: "3rem", width: "3rem" }} color={"primary"} />
									</InputAdornment>
								)}
							</>
						),
					}}
					inputProps={{ min: 0 }}
					FormHelperTextProps={{ className: helperColor ? classes.helperTextColor : classes.helperText }}
				/>
			)}
		</>
	);
}

export default CustomInput;
